// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-font {
  text-align: end !important;
  font-size: 20px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/csv-file-list/csv-file-details/csv-file-details.component.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;EACA,0BAAA;AAHF","sourcesContent":["// .download-icon-font ion-icon {\n//   margin: 9px 8px 9px 350px;\n// }\n\n.download-font{\n  text-align: end !important;\n  font-size: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
